import {reject} from 'ramda'
import {Player} from './Player'

export const SelectedPlayers = ({team, setTeam}) => {
    
    const handleClick = ({item}) => {
        const rejectItem = (n) => n === item
        setTeam(reject(rejectItem, team)) 
    }
    return (
        <div>
            {team.map((item, i) => <Player key={"Selected" + i} handleClick={handleClick} player={item}/>)}
        </div> 
    )
}